import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import JobRoleRequestForm from "./JobRoleRequestForm";
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import { 
	getJobRoleRequestList, 
	doJobRoleRequestDelete,
} from "../../../../redux/jobrolerequest/jobRoleRequestState";
import { MODULE_JOBROLE_REQS } from "variables/constants";
import { useCRUDAccess } from "utils/useCRUDAccess";


const JobRoleRequestTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {
	const checkCRUDAccess = useCRUDAccess();
	const accessRights = checkCRUDAccess(MODULE_JOBROLE_REQS, ['view', 'add', 'edit', 'delete'], true);

  	const columns = [
		{
	        title: `Client`,
	        dataIndex: 'client_name',
	        key: 'client_name',
	        width: '30%',
	        render:(client_name) => <span>{client_name}</span> 
	    },
		{
	        title: `Position Title`,
	        dataIndex: 'job_role_title',
	        key: 'job_role_title',
	        width: '30%',
	        render:(job_role_title) => <span>{job_role_title}</span> 
	    },
		{
	        title: <div className="text-right">Headcount</div>,
	        dataIndex: 'jrr_count',
	        key: 'jrr_count',
	        width: '10%',
	        render:(jrr_count) => <div className="text-right">{jrr_count}</div>,
	    },
		{
	        title: `Status`,
	        dataIndex: 'status_name',
	        key: 'status_name',
	        width: '15%',
	        render:(status_name) => <span>{status_name}</span> 
	    },
		{
	        title: `Target Date`,
	        dataIndex: 'jrr_target_date',
	        key: 'jrr_target_date',
	        width: '15%',
	        render:(jrr_target_date) => <span>{jrr_target_date}</span> 
	    },
		
	    {
	        // title: <PopupButton id="add_job_role_request" title="Add Job Request" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_JOBROLE_REQS}>
			// 			<JobRoleRequestForm recordId="0" mode="edit" />
			// 		</PopupButton>,
	        dataIndex: 'jrr_id',
	        key: 'jrr_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute="/console/job-role-requests" 
									recordId={record?.jrr_id} 
									deleteHandler={doDelete}
									allowEdit={(accessRights.edit && record.jrr_status_id === 74)}
									allowDelete={(accessRights.delete && record.jrr_status_id === 74)}
									editMode="modal"
									title="Edit Job Request"
									closeHandler={doRecordReset}
									editHandler={(recordId, doRecordReset ) => (
										<JobRoleRequestForm 
											recordId={recordId} 
											mode="edit" 
											onCancel={doRecordReset} 
										/>
									)}
								/>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.jrr_id}
					scroll={{ x: "max-content" }}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.jobRoleRequest.jobRoleRequestList?.items,
	pagination: state.jobRoleRequest.jobRoleRequestList?.pagination,
	filters: state.jobRoleRequest.jobRoleRequestList?.filters,
	requesting: state.jobRoleRequest.jobRoleRequestList?.requesting,
	error: state.jobRoleRequest.jobRoleRequestList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getJobRoleRequestList(filters)),
	doDelete: (id) => dispatch(doJobRoleRequestDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRoleRequestTable);
